import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import AudioButton from "./AudioButton";
import { audioVideoSliceActions } from "../../Store/Slices/AudioVideoSlice";
import {
  Box,
  IconButton,
  Grid,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import { audioSmartCheck, audioSmartCheckUnScripted } from "../../Js/Common";
import RecordRTC, {
  RecordRTCPromisesHandler,
  StereoAudioRecorder,
} from "recordrtc";
import { uploadRecordFile, blobToBase64 } from "../../Js/Common";
import { currentAssetSliceActions } from "../../Store/Slices/CurrentAssetSlice";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import Confirmation from "../Modal/Confirmation";
import Crunker from "crunker";
import worker_script from "../../Js/mp3Worker.js";
import Button from "@mui/material/Button";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { fancyTimeHhMmSs } from "../../Js/TimeAndDate.js";

import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import DeleteIcon from "@mui/icons-material/Delete";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";

import WaveSurfer from "wavesurfer.js";

// Global variables

const RecordButtonForBroadcast = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const upload = useRef();

  const [soundData, setSoundData] = useState(null);
  const [isFinished, setIsFinished] = useState(false);
  const [uri, setUri] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [smartCheckPercent, setSmartCheckPercent] = useState(0);
  const [attempt, setAttempt] = useState(0);
  const [recording, setRecording] = useState(null);
  const [stopRecordFlg, setStopRecordFlg] = useState(false);
  const [timer, setTimer] = useState(null);
  const [allAudios, setAllAudios] = useState([]);
  const [allAudiosBlob, setAllAudiosBlob] = useState([]);
  const [isPlayingArr, setIsPlayingArr] = useState([]);
  const [alreadyRecordedAudioAvailable, setAlreadyRecordedAudioAvailable] =
    useState(false);
  const [allAudiosStatus, setAllAudiosStatus] = useState([]);
  const [fullAudioTotalDuration, setFullAudioTotalDuration] = useState(0);
  const [fullAudioCurrentDuration, setFullAudioCurrentDuration] = useState(0);
  const [uploadWarning, setUploadWarning] = useState(false);
  const [isDragFlag, setIsDragFlag] = useState(false);

  const [wavesurferObj, setWavesurferObj] = useState(null);

  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { serverRole } = useSelector((state) => state.defs);

  useEffect(() => {
    setIsPlaying(false);
    setRecording(null);
    setUri(null);
    setSmartCheckPercent(0);
    dispatch(currentAssetSliceActions.setRecordingContinueIndex(-1));
    dispatch(currentAssetSliceActions.setRecordingAudioContinueIndex(-1));
  }, [props.index, props.resetComponent]);

  useEffect(() => {
    if (isPlayingArr.indexOf(true) == -1 && !isPlaying) {
      setIsDragFlag(false);
    } else {
      setIsDragFlag(true);
    }
  }, [isPlayingArr, isPlaying]);
  
  useEffect(()=> {
    if(fullAudioTotalDuration != 0 && allAudios.length == 0){
      setFullAudioTotalDuration(0);
      setFullAudioCurrentDuration(0);
    }
  },[fullAudioTotalDuration, allAudios])

  useEffect(() => {
    console.log("URI", uri);
    if (uri) {
      console.log(":::::", wavesurferObj);
      if (!wavesurferObj) {
        const wavesurfer = WaveSurfer.create({
          container: "#waveform",
          waveColor: "#4751AE",
          progressColor: "#131c7d",
          url: uri,
          height: 80,
          // Set a bar width
          barWidth: 2,
          // Optionally, specify the spacing between bars
          barGap: 3,
          // And the bar radius
          barRadius: 2,
          interact: false,
        });
        // wavesurfer.on("ready", (arg) => {
        //   console.log("ready");
        //   dispatch(commonSliceActions.setLoader(false));
        // });
        wavesurfer.on("load", () => {
          console.log("load");
          dispatch(commonSliceActions.setLoader(true));
        });
        wavesurfer.on("redrawcomplete", () => {
          setTimeout(() => {
            dispatch(commonSliceActions.setLoader(false));
          },1000);
        });
        setWavesurferObj(wavesurfer);
      } else {
        if (allAudios.length > 0) {
          if (uri.includes("blob")) {
            dispatch(commonSliceActions.setLoader(true));
            wavesurferObj.load(uri);
            wavesurferObj.setTime(0);
          } else {
            let port = sessionStorage.getItem("port_data")
              ? sessionStorage.getItem("port_data").split(",")
              : process.env.REACT_APP_PORT_DATA.split(",");
            wavesurferObj.load(
              `${
                sessionStorage.getItem("site_ip")
                  ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                  : process.env.REACT_APP_SERVER_API
              }/media/userUploadedData/broadCast/${uri}`
            );
          }
        } else {
          wavesurferObj.destroy();
          setWavesurferObj(null);
        }
      }
    } else {
      if (wavesurferObj) {
        wavesurferObj.destroy();
        setWavesurferObj(null);
      }
    }
  }, [WaveSurfer, uri, allAudios]);

  useEffect(() => {
    if (wavesurferObj) {
      if (isPlaying) {
        wavesurferObj.play();
      } else {
        wavesurferObj.pause();
      }
    }
  }, [isPlaying, wavesurferObj]);

  useEffect(() => {
    console.log("!@#$URIIII", props.alreadyRecordedClips);
    let alias = userInfo.username.split("@");
    if (props.alreadyRecorded) {
      setUri(`pending/${alias[alias.length - 1]}/${props.alreadyRecorded}`);
      setAlreadyRecordedAudioAvailable(true);
    } else {
      setUri(null);
      setAlreadyRecordedAudioAvailable(false);
    }

    if (props.alreadyRecordedClips && props.alreadyRecordedClips.length > 0) {
      let tempArr = [];
      let newArr = props.alreadyRecordedClips.map((val) => {
        tempArr.push(`pending/${alias[alias.length - 1]}/${val.name}`);
        return {
          ...val,
          name: `pending/${alias[alias.length - 1]}/${val.name}`,
        };
      });
      setAllAudios(tempArr);
      setAllAudiosStatus(newArr);
    } else {
      setAllAudios([]);
    }
    setIsPlaying(false);
    setRecording(null);
    setSmartCheckPercent(0);
  }, [props.alreadyRecorded, userInfo, props.alreadyRecordedClips]);

  useEffect(() => {
    if (recording) {
      if (props.index != undefined) {
        dispatch(
          currentAssetSliceActions.setRecordingContinueIndex(props.index)
        );
      } else {
        dispatch(currentAssetSliceActions.setRecordingContinueIndex(0));
      }
    } else {
      dispatch(currentAssetSliceActions.setRecordingContinueIndex(-1));
    }
  }, [recording]);

  useEffect(() => {
    if (isPlaying) {
      if (props.index != undefined) {
        dispatch(
          currentAssetSliceActions.setRecordingAudioContinueIndex(props.index)
        );
      } else {
        dispatch(currentAssetSliceActions.setRecordingAudioContinueIndex(0));
      }
    } else {
      dispatch(currentAssetSliceActions.setRecordingAudioContinueIndex(-1));
    }
  }, [isPlaying]);

  async function startRecording() {
    try {
      console.log("Requesting permissions..");
      let stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false,
      });
      let recorder = new RecordRTCPromisesHandler(stream, {
        type: "audio",
        audioType: "audio/wav",
        mimeType: "audio/wav",
        recorderType: StereoAudioRecorder,
      });

      recorder.startRecording();
      dispatch(audioVideoSliceActions.setCurrentAudioSrc(null));
      if (props.startRecord) {
        props.startRecord(true);
      }
      setRecording(recorder);
      console.log("Recording started");
    } catch (err) {
      console.error("Failed to start recording", err);
    }
  }

  const combineAudios = async (audioArray, audioStatus = []) => {
    var crunker = new Crunker();
    let audiosPath = [...audioArray];
    let livelinks = [];
    if (audioStatus.length > 0) {
      let port = sessionStorage.getItem("port_data")
        ? sessionStorage.getItem("port_data").split(",")
        : process.env.REACT_APP_PORT_DATA.split(",");
      audiosPath = audioStatus.filter(
        (val1) => val1.modification !== "deleted"
      );
      audiosPath = audiosPath.map((val) => {
        if (val.status == "fromServer") {
          return `${
            sessionStorage.getItem("site_ip")
              ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
              : process.env.REACT_APP_SERVER_API
          }/media/userUploadedData/broadCast/${val.name}`;
        } else {
          return val.name;
        }
      });
    }

    const buffers = await crunker.fetchAudio(...audiosPath);
    console.log("SSSSSbuffers", buffers);
    const merged = await crunker["concatAudio"](buffers);
    const output = await crunker.export(merged, "audio/mp3");
    var arrayBuffer = await output.blob.arrayBuffer();
    //console.log("%%%%%%%%earrayBuffer", arrayBuffer);

    let mp3Worker = new Worker(worker_script);
    mp3Worker.postMessage({
      arrayBuffer: arrayBuffer,
      link: `${window.location.origin}/js/lame.min.js`,
    });

    mp3Worker.onmessage = async (e) => {
      const combinedAudio = e.data;
      const localCombinedUri = URL.createObjectURL(combinedAudio);
      setUri(localCombinedUri);
      console.log("e.data", e.data);
      props.fullAudio(e.data);
      //await crunker.download(e.data, `${assignmentname}_${randomNumber(5000)}`);
      mp3Worker.terminate();
      setAlreadyRecordedAudioAvailable(false);
    };
  };

  async function stopRecording() {
    console.log("Stopping recording..");
    await recording.stopRecording();
    if (props.startRecord) {
      props.startRecord(false);
    }
    setRecording(undefined);
    clearTimeout(timer);
    setTimer(null);
    const blob = await recording.getBlob();
    const localUri = URL.createObjectURL(blob);
    setUri(localUri);
    let audiosTemp = [...allAudios];
    let audioTempBlb = [...allAudiosBlob];
    let audioStatus = [...allAudiosStatus];
    if (allAudiosStatus.length > 0) {
      audioStatus.push({
        name: localUri,
        status: "local",
        modification: "no",
      });
      setAllAudiosStatus(audioStatus);
      if (props.updateAudioStatus) {
        props.updateAudioStatus(audioStatus);
      }
    }
    console.log("audiosTemp", audiosTemp);
    audiosTemp.push(localUri);
    audioTempBlb.push(blob);
    combineAudios(audiosTemp, audioStatus);
    setAllAudios(audiosTemp);
    setAllAudiosBlob(audioTempBlb);
    props.allAudios(audioTempBlb);
    setIsPlayingArr(new Array(audiosTemp.length).fill(false));
    if (props.recordedAudio) {
      props.recordedAudio(localUri);
    }
    let uploadFlag = false;

    if (
      props.checkOnPause &&
      serverRole &&
      serverRole.toLowerCase() == "web_host"
    ) {
      let response;
    } else {
      if (uploadFlag && props.checkOnPause) {
        //let filename = await uploadRecordFile(blob);
        //props.smartCheck("site_server", filename.data.id);
      }
      if (uploadFlag && !props.checkOnPause && props.smartCheck) {
        //let filename = await uploadRecordFile(blob);
        //props.smartCheck("web_host", filename.data.id);
      }
    }
    if (props.uploadOnPause) {
      // let content = await blobToBase64(blob);
      // console.log("content", content);
      //let filename = await uploadRecordFile(blob);
      //props.uploadedAudioName(filename.data.id);
    }
  }

  const removeClip = (index) => {
    let tempArr = [...allAudios];
    let tempArr2 = [...allAudiosBlob];
    let tempArrStatus = [];
    console.log("tempArr", tempArr);
    if (
      allAudiosStatus.length == 0 ||
      allAudiosStatus[index]["status"] == "local"
    ) {
      tempArr.splice(index, 1);
      setAllAudios(tempArr);
      tempArr2.splice(index, 1);
      setAllAudiosBlob(tempArr2);
      if (allAudiosStatus.length > 0) {
        tempArrStatus = [...allAudiosStatus];
        tempArrStatus.splice(index, 1);
        setAllAudiosStatus(tempArrStatus);
        if (props.updateAudioStatus) {
          props.updateAudioStatus(tempArrStatus);
        }
      }
    } else {
      tempArrStatus = [...allAudiosStatus];
      tempArrStatus[index]["modification"] = "deleted";
      setAllAudios(tempArr, tempArrStatus);
      props.updateAudioStatus(tempArrStatus);
    }

    if (
      (props.mode == "fromDraft" && tempArr.length > 0) ||
      (props.mode == "fromRejected" &&
        tempArrStatus.filter((o) => o.modification != "deleted").length > 0)
    ) {
      console.log("HELLLOOOOOOOO");
      combineAudios(tempArr, tempArrStatus);
    } else {
      setUri(null);
    }
    props.allAudios(tempArr2);
  };

  const downloadBase64Audio = async () => {
    if (props.alreadyRecorded) {
      let port = sessionStorage.getItem("port_data");
      let tempuri = uri.includes("blob") ? `${uri}`:`${
        sessionStorage.getItem("site_ip")
          ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
          : process.env.REACT_APP_SERVER_API
      }/media/userUploadedData/broadCast/${uri}`;
      fetch(tempuri)
        // check to make sure you didn't have an unexpected failure (may need to check other things here depending on use case / backend)
        .then((resp) =>
          resp.status === 200
            ? resp.blob()
            : Promise.reject("something went wrong")
        )
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          // the filename you want
          a.download = `${props.title
            .split(" ")
            .join("_")}_ww_podcast_audio.mp3`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => alert("oh no!"));
    } else {
      const link = document.createElement("a");
      link.href = await blobUrlToBase64(uri);
      link.download = `${props.title
        .split(" ")
        .join("_")}_ww_podcast_audio.mp3`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const blobUrlToBase64 = async (blobUrl) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      const xhr = new XMLHttpRequest();
      xhr.responseType = "blob";

      xhr.onload = function () {
        reader.readAsDataURL(xhr.response);
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.onerror = function (ev) {
          reject(
            `Exception reading Blob > xhr.response: ${xhr.response}\nLast Progress Event: ${ev}`
          );
        };
      };
      xhr.onerror = function (ev) {
        reject(
          `Exception fetching Blob > BlobUrl: ${blobUrl}\nLast Progress Event: ${ev}`
        );
      };

      xhr.open("GET", blobUrl);
      xhr.send();
    });
  };

  const uploadAudio = (event) => {
    const file = event.target.files[0];
    if (file) {
      const blob = new Blob([file], { type: file.type });
      console.log(blob); //

      const localUri = URL.createObjectURL(blob);
      setUri(localUri);
      let audiosTemp = [];
      let audioTempBlb = [];
      let audioStatus = [];
      audioStatus.push({
        name: localUri,
        status: "local",
        modification: "no",
      });
      setAllAudiosStatus(audioStatus);
      console.log("audiosTemp", audiosTemp);
      audiosTemp.push(localUri);
      audioTempBlb.push(blob);
      props.fullAudio(blob);
      combineAudios(audiosTemp, audioStatus);
      setAllAudios(audiosTemp);
      setAllAudiosBlob(audioTempBlb);
      props.allAudios(audioTempBlb);
      setIsPlayingArr(new Array(audiosTemp.length).fill(false));
      if (props.recordedAudio) {
        props.recordedAudio(localUri);
      }
      upload.current.value = "";
      upload.current.type = "text";
      upload.current.type = "file";
    }
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;
    const items = reorder(allAudios, source.index, destination.index);
    setAllAudios(items);
    combineAudios(items);
  };

  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const grid = 8;
  const getListStyle = (isDraggingOver) => ({
    display: "flex",
    padding: grid,
    overflow: "auto",
    width: "100%",
  });

  return (
    <>
      <IconButton
        onClick={recording ? stopRecording : startRecording}
        sx={{
          mx: 1,
          border: 1,
          borderColor: "#EFEFEF",
          backgroundColor: "#FFFFFF",
          boxShadow: 2,
          color: recording ? "primary.error" : "primary.main",
         
        }}
        size={props.size ? props.size : "medium"}
        disabled={
          (!props.disablePercentageLimitOff &&
            smartCheckPercent >=
              +process.env.REACT_APP_SMART_CHECK_DISABLE_PERCENTAGE) ||
          (props.numberOfAttemptes &&
            userInfo.rolesInfo.title.toLowerCase() == "learner" &&
            +props.numberOfAttemptes == +attempt) ||
          props.disabled ||
          isPlaying ||
          props.disabledAll
        }
      >
        <KeyboardVoiceIcon
          sx={{
            "@media (min-width: 1636px)": {
              fontSize: "2rem",
            },
          }}
        />
      </IconButton>
      {uri && !alreadyRecordedAudioAvailable && (
        <AudioButton
          localUri={uri}
          playStatus={(status, ended, resetFlag) => {
            setIsPlaying(status);
          }}
          onupdate={(obj) => {
            if (allAudios.length > 0) {
              setFullAudioTotalDuration(obj.duration);
              setFullAudioCurrentDuration(obj.currentTime);
            }
            console.log("obj", obj);
          }}
          metadata={(duration) => {
            if (allAudios.length > 0) {
              setFullAudioTotalDuration(duration);
              console.log("duration", duration);
            }
          }}
          disabled={
            (props.audioDisable == undefined && props.disabled) ||
            recording ||
            props.audioDisable ||
            props.disabledAll ||
            isPlayingArr.indexOf(true) > -1
          }
          volume={0}
        >
          <IconButton
            sx={{
              mx: 1,
              border: 1,
              borderColor: "#EFEFEF",
              backgroundColor: "primary.main",
              boxShadow: 2,
              color: "#FFFFFF",
            
            }}
            size={props.size ? props.size : "medium"}
            disabled={
              (props.audioDisable == undefined && props.disabled) ||
              recording ||
              props.audioDisable ||
              props.disabledAll ||
              isPlayingArr.indexOf(true) > -1
            }
          >
            {isPlaying ? (
              <PauseIcon
                sx={{
                  "@media (min-width: 1636px)": {
                    fontSize: "2rem",
                  },
                }}
              />
            ) : (
              <PlayArrowIcon
                sx={{
                  "@media (min-width: 1636px)": {
                    fontSize: "2rem",
                  },
                }}
              />
            )}
          </IconButton>
        </AudioButton>
      )}
      {uri && alreadyRecordedAudioAvailable && (
        <AudioButton
          broadcastUri={uri}
          playStatus={(status) => setIsPlaying(status)}
          metadata={(duration) => {
            if (allAudios.length > 0) {
              setFullAudioTotalDuration(duration);
              console.log("duration", duration);
            }
          }}
          disabled={
            (props.audioDisable == undefined && props.disabled) ||
            recording ||
            props.audioDisable ||
            props.disabledAll ||
            isPlayingArr.indexOf(true) > -1
          }
          onupdate={(obj) => {
            if (allAudios.length > 0) {
              setFullAudioTotalDuration(obj.duration);
              setFullAudioCurrentDuration(obj.currentTime);
              console.log("obj", obj);
            }
          }}
        >
          <IconButton
            sx={{
              mx: 1,
              border: 1,
              borderColor: "#EFEFEF",
              backgroundColor: "primary.main",
              boxShadow: 2,
              color: "#FFFFFF",
              
            }}
            size={props.size ? props.size : "medium"}
            disabled={
              (props.audioDisable == undefined && props.disabled) ||
              recording ||
              props.audioDisable ||
              props.disabledAll ||
              isPlayingArr.indexOf(true) > -1
            }
          >
            {isPlaying ? (
              <PauseIcon
                sx={{
                  "@media (min-width: 1636px)": {
                    fontSize: "2rem",
                  },
                }}
              />
            ) : (
              <PlayArrowIcon
                sx={{
                  "@media (min-width: 1636px)": {
                    fontSize: "2rem",
                  },
                }}
              />
            )}
          </IconButton>
        </AudioButton>
      )}

      <Grid sm={12} md={12} sx={{ mt: 2 }}>
        <Box
           
          sx={{
            textAlign: "justify",
            border: 1,
            borderColor: "#D9D9D9",
            borderRadius: 4,
          }}
        >
          <Card
            className={classes.card1}
            sx={{
              boxShadow: 0,
             
            }}
          >
            <CardContent
              sx={{
                height: "22vh",
                p: 0,
              }}
            >
              <Box
                hover
                sx={{
                  backgroundColor: "#F5F7FF",
                  diaplay: "flex",
                  color: "primary.main",
                  cursor: "pointer",
                  
                }}
              >
                <Grid
                  container
                  sx={{
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Grid
                    item
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <IconButton
                      onClick={() => {
                        //navigation(-1);
                      }}
                    >
                      <KeyboardVoiceIcon
                        sx={{
                          fontSize: "1.1rem",
                          backgroundColor: "#f4cbcb",
                          color: "#910d0d",
                          padding: 0.5,
                          borderRadius: 2,
                          "@media (min-width: 1636px)": {
                            fontSize: "3rem",
                          },
                        }}
                      />
                    </IconButton>
                    <Typography
                      sx={{
                        color: "primary.main",
                        fontWeight: "600",
                        fontSize: "0.9rem",
                        "@media (min-width: 1636px)": {
                          fontSize: "2rem",
                        },
                      }}
                    >
                      Overall Audio
                    </Typography>
                  </Grid>
                  <Grid item sx={{ marginRight: 3 }}>
                    <Typography
                      sx={{
                        color: "primary.main",
                        fontWeight: "600",
                        fontSize: "0.9rem",
                        "@media (min-width: 1636px)": {
                          fontSize: "2rem",
                        },
                      }}
                    >
                      {`${fancyTimeHhMmSs(
                        fullAudioCurrentDuration * 1000
                      )} | ${fancyTimeHhMmSs(fullAudioTotalDuration * 1000)}`}
                    </Typography>
                    {/* <IconButton sx={{}}>
                      <ModeEditOutlineOutlinedIcon
                        sx={{
                          fontSize: "1.1rem",
                          color: "#DB8829",
                        }}
                      />
                    </IconButton>
                    <IconButton sx={{}}>
                      <DeleteIcon
                        sx={{
                          fontSize: "1.1rem",
                          color: "#DB8829",
                        }}
                      />
                    </IconButton> */}
                  </Grid>
                </Grid>
              </Box>
              <Box
                sx={{
                  border: 1,
                  borderColor: "#D9D9D9",
                  mt: 1,
                  pt: 2,
                  mx: 1,
                  height: "12vh",
                  borderRadius: 3,
                  backgroundColor: "#E6E2FC",
                }}
                component={"div"}
                id="waveform"
              ></Box>
              <Box
                sx={{
                  textAlign: "right",
                  pr: 2,
                  mt: 1,
                  color: "#DB8829",
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    backgroundColor: "@DB8829",
                    color: "#FFFFFF",
                    fontSize: "0.8rem",
                    mr: 1,
                  }}
                  onClick={() => {
                    if (allAudios && allAudios.length > 0) {
                      setUploadWarning(true);
                    } else {
                      upload.current.click();
                    }
                  }}
                  disabled={recording}
                >
                  Upload
                </Button>
                {allAudios && allAudios.length > 0 && (
                  <>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        backgroundColor: "@DB8829",
                        color: "#FFFFFF",
                        fontSize: "0.8rem",
                        mr: 1,
                      }}
                      onClick={downloadBase64Audio}
                      disabled={
                        recording ||
                        (props.mode == "fromDraft" && allAudios.length == 0) ||
                        (props.mode == "fromRejected" &&
                          allAudiosStatus.filter(
                            (o) => o.modification != "deleted"
                          ).length == 0)
                      }
                    >
                      Download
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        backgroundColor: "@DB8829",
                        color: "#FFFFFF",
                        fontSize: "0.8rem",
                      }}
                      onClick={props.submitFullAudio}
                      disabled={
                        recording ||
                        (props.mode == "fromDraft" && allAudios.length == 0) ||
                        (props.mode == "fromRejected" &&
                          allAudiosStatus.filter(
                            (o) => o.modification != "deleted"
                          ).length == 0)
                      }
                    >
                      submit
                    </Button>
                  </>
                )}
              </Box>
            </CardContent>
            {/* <CardActions sx={{ justifyContent: "flex-end", py: 0, pb: 1 }}>
                                    <IconButton aria-label="Go" size="small" sx={{ borderRadius: '50%', backgroundColor: '#F5F5F5', color: 'primary.main', padding: 0.5 }}>
                                        <NavigateNextIcon fontSize="inherit" sx={{ fontSize: '1.5rem' }} />
                                    </IconButton>
                                </CardActions> */}
          </Card>
        </Box>
      </Grid>

      <Grid container sx={{ mt: 2 }}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable" direction="horizontal">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
                {...provided.droppableProps}
                 
              >
                {allAudios &&
                  allAudios.map((val, ind) => (
                    <Draggable
                      key={`${ind}_drag1`}
                      draggableId={`${ind}_drag1`}
                      index={ind}
                      isDragDisabled={
                        isDragFlag || props.mode == "fromRejected"
                      }
                    >
                      {(provided, snapshot) => (
                        <Grid item xs={3} sx={{ mt: 2 }} key={`${ind}_clip`}>
                          <Box
                            sx={{ display: "flex", mx: 1 }}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            {/* <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              width: "90%",
                            }}
                          >
                            <CardContent sx={{ flex: "1 0 auto" }}>
                              <Typography component="div" variant="h5">
                                Clip {ind + 1}
                                <GraphicEqIcon sx={{ ml: 2 }}></GraphicEqIcon>
                                {allAudiosStatus[ind] &&
                                  allAudiosStatus[ind].status &&
                                  allAudiosStatus[ind].status == "fromServer" && (
                                    <CloudQueueIcon sx={{ ml: 2 }}></CloudQueueIcon>
                                  )}
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                component="div"
                                sx={{ color: "text.secondary" }}
                              >
                                {""}
                              </Typography>
                            </CardContent>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                pl: 1,
                                pb: 1,
                              }}
                            >
                              {(!allAudiosStatus[ind] ||
                                (allAudiosStatus[ind] &&
                                  allAudiosStatus[ind]["modification"] == "no")) && (
                                <IconButton
                                  aria-label="play/pause"
                                  onClick={() => {
                                    removeClip(ind);
                                  }}
                                >
                                  <DeleteIcon
                                    sx={{
                                      height: 30,
                                      width: 30,
                                      color: "secondary.main",
                                    }}
                                  />
                                </IconButton>
                              )}
                              {allAudiosStatus[ind] &&
                                allAudiosStatus[ind]["modification"] == "deleted" && (
                                  <span>Deleted</span>
                                )}
                            </Box>
                          </Box> */}
                            <Box
                               
                              sx={{ textAlign: "justify" }}
                            >
                              <Card
                                className={classes.card2}
                                sx={{
                                  boxShadow: 0,
                                  border: 2,
                                  borderColor: "#D9D9D9",
                                  borderRadius: 4,
                                  borderStyle: "dotted",
                                  
                                }}
                              >
                                <CardContent
                                  sx={{
                                    height: "8rem",
                                    p: 0,
                                  }}
                                >
                                  <Box
                                    hover
                                    sx={{
                                      diaplay: "flex",
                                      color: "primary.main",
                                      cursor: "pointer",
                                      
                                    }}
                                  >
                                    <Grid
                                      container
                                      sx={{
                                        flexDirection: "row",
                                        alignContent: "center",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <Grid
                                        item
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <IconButton
                                          onClick={() => {
                                            //navigation(-1);
                                          }}
                                        >
                                          <KeyboardVoiceIcon
                                            sx={{
                                              fontSize: "1.1rem",
                                              backgroundColor: "#f4cbcb",
                                              color: "#910d0d",
                                              padding: 0.5,
                                              borderRadius: 2,
                                              "@media (min-width: 1636px)": {
                                                fontSize: "3rem",
                                              },
                                            }}
                                          />
                                        </IconButton>
                                        <Typography
                                          sx={{
                                            color: "primary.main",
                                            fontWeight: "600",
                                            fontSize: "0.9rem",
                                            "@media (min-width: 1636px)": {
                                              fontSize: "2rem",
                                            },
                                          }}
                                        >
                                          Clip {ind + 1}
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        {/* <IconButton>
                                        <ModeEditOutlineOutlinedIcon
                                          sx={{
                                            fontSize: "1.1rem",
                                            color: "#DB8829",
                                          }}
                                        />
                                      </IconButton> */}
                                        {(!allAudiosStatus[ind] ||
                                          (allAudiosStatus[ind] &&
                                            allAudiosStatus[ind][
                                              "modification"
                                            ] == "no")) && (
                                          <IconButton
                                            onClick={() => {
                                              removeClip(ind);
                                            }}
                                          >
                                            <DeleteIcon
                                              sx={{
                                                fontSize: "1.1rem",
                                                color: "#DB8829",
                                              }}
                                            />
                                          </IconButton>
                                        )}
                                      </Grid>
                                    </Grid>
                                  </Box>
                                  <Box
                                    sx={{
                                      mx: 3,
                                      borderRadius: 3,
                                      backgroundColor: "#e6e2fc",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: "0.6rem",
                                        color: "#DB8829",
                                        py: 1,
                                      }}
                                    >
                                      Tap Record <br />
                                      to play
                                    </Typography>
                                  </Box>
                                  <Grid
                                    container
                                    sx={{ justifyContent: "space-evenly" }}
                                  >
                                    {allAudiosStatus[ind] &&
                                      allAudiosStatus[ind]["modification"] ==
                                        "deleted" && (
                                        <Grid item>
                                          <Box
                                            sx={{
                                              textAlign: "center",
                                              mt: 1,
                                              color: "#DB8829",
                                            }}
                                          >
                                            <span>Deleted</span>
                                          </Box>
                                        </Grid>
                                      )}
                                    <Grid item>
                                      <Box
                                        sx={{
                                          textAlign: "center",
                                          mt: 1,
                                          color: "#DB8829",
                                        }}
                                      >
                                        {val && !allAudiosStatus[ind] && (
                                          <AudioButton
                                            localUri={val}
                                            playStatus={(
                                              status,
                                              ended,
                                              resetFlag
                                            ) => {
                                              if (!resetFlag || isPlaying) {
                                                let playingStts = new Array(
                                                  allAudios.length
                                                ).fill(false);
                                                playingStts[ind] = status;
                                                setIsPlayingArr(playingStts);
                                              }
                                            }}
                                            disabled={isPlaying}
                                          >
                                            <IconButton
                                              sx={{
                                                mx: 1,
                                                border: 1,
                                                borderColor: "#EFEFEF",
                                                backgroundColor: "primary.main",
                                                boxShadow: 2,
                                                color: "#FFFFFF",
                                                
                                              }}
                                              size={"medium"}
                                              disabled={isPlaying}
                                              // disabled={
                                              //   (props.audioDisable == undefined &&
                                              //     props.disabled) ||
                                              //   recording ||
                                              //   props.audioDisable ||
                                              //   props.disabledAll
                                              // }
                                            >
                                              {isPlayingArr[ind] ? (
                                                <PauseIcon
                                                  sx={{
                                                    "@media (min-width: 1636px)":
                                                      {
                                                        fontSize: "2rem",
                                                      },
                                                  }}
                                                />
                                              ) : (
                                                <PlayArrowIcon
                                                  sx={{
                                                    "@media (min-width: 1636px)":
                                                      {
                                                        fontSize: "2rem",
                                                      },
                                                  }}
                                                />
                                              )}
                                            </IconButton>
                                          </AudioButton>
                                        )}
                                        {val &&
                                          allAudiosStatus[ind] &&
                                          (!allAudiosStatus[ind].status ||
                                            allAudiosStatus[ind].status ==
                                              "local") && (
                                            <AudioButton
                                              localUri={val}
                                              playStatus={(
                                                status,
                                                ended,
                                                resetFlag
                                              ) => {
                                                if (!resetFlag || isPlaying) {
                                                  let playingStts = new Array(
                                                    allAudios.length
                                                  ).fill(false);
                                                  playingStts[ind] = status;
                                                  setIsPlayingArr(playingStts);
                                                }
                                              }}
                                              disabled={isPlaying}
                                            >
                                              <IconButton
                                                sx={{
                                                  mx: 1,
                                                  border: 1,
                                                  borderColor: "#EFEFEF",
                                                  backgroundColor:
                                                    "primary.main",
                                                  boxShadow: 2,
                                                  color: "#FFFFFF",
                                                 
                                                }}
                                                size={"medium"}
                                                disabled={isPlaying}
                                                // disabled={
                                                //   (props.audioDisable == undefined &&
                                                //     props.disabled) ||
                                                //   recording ||
                                                //   props.audioDisable ||
                                                //   props.disabledAll
                                                // }
                                              >
                                                {isPlayingArr[ind] ? (
                                                  <PauseIcon
                                                    sx={{
                                                      "@media (min-width: 1636px)":
                                                        {
                                                          fontSize: "2rem",
                                                        },
                                                    }}
                                                  />
                                                ) : (
                                                  <PlayArrowIcon
                                                    sx={{
                                                      "@media (min-width: 1636px)":
                                                        {
                                                          fontSize: "2rem",
                                                        },
                                                    }}
                                                  />
                                                )}
                                              </IconButton>
                                            </AudioButton>
                                          )}
                                        {val &&
                                          allAudiosStatus[ind] &&
                                          allAudiosStatus[ind].status &&
                                          allAudiosStatus[ind].status ==
                                            "fromServer" && (
                                            <AudioButton
                                              broadcastUri={val}
                                              playStatus={(
                                                status,
                                                ended,
                                                resetFlag
                                              ) => {
                                                if (!resetFlag || isPlaying) {
                                                  let playingStts = new Array(
                                                    allAudios.length
                                                  ).fill(false);
                                                  playingStts[ind] = status;
                                                  setIsPlayingArr(playingStts);
                                                }
                                              }}
                                              disabled={isPlaying}
                                            >
                                              <IconButton
                                                sx={{
                                                  mx: 1,
                                                  border: 1,
                                                  borderColor: "#EFEFEF",
                                                  backgroundColor:
                                                    "primary.main",
                                                  boxShadow: 2,
                                                  color: "#FFFFFF",
                                                  
                                                }}
                                                size={"medium"}
                                                disabled={isPlaying}
                                                // disabled={
                                                //   (props.audioDisable == undefined &&
                                                //     props.disabled) ||
                                                //   recording ||
                                                //   props.audioDisable ||
                                                //   props.disabledAll
                                                // }
                                              >
                                                {isPlayingArr[ind] ? (
                                                  <PauseIcon
                                                    sx={{
                                                      "@media (min-width: 1636px)":
                                                        {
                                                          fontSize: "2rem",
                                                        },
                                                    }}
                                                  />
                                                ) : (
                                                  <PlayArrowIcon
                                                    sx={{
                                                      "@media (min-width: 1636px)":
                                                        {
                                                          fontSize: "2rem",
                                                        },
                                                    }}
                                                  />
                                                )}
                                              </IconButton>
                                            </AudioButton>
                                          )}
                                        {/* <Typography
                                        sx={{
                                          fontSize: "0.6rem",
                                          color: "#DB8829",
                                        }}
                                      >
                                        Play
                                      </Typography> */}
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </CardContent>
                                {/* <CardActions sx={{ justifyContent: "flex-end", py: 0, pb: 1 }}>
                                            <IconButton aria-label="Go" size="small" sx={{ borderRadius: '50%', backgroundColor: '#F5F5F5', color: 'primary.main', padding: 0.5 }}>
                                                <NavigateNextIcon fontSize="inherit" sx={{ fontSize: '1.5rem' }} />
                                            </IconButton>
                                        </CardActions> */}
                              </Card>
                            </Box>
                          </Box>
                        </Grid>
                      )}
                    </Draggable>
                  ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Grid>
      <input
        id="upload"
        ref={upload}
        type="file"
        accept=".mp3"
        style={{ display: "none" }}
        onInput={(event) => {
          uploadAudio(event);
        }}
      />
      <Confirmation
        image="error"
        primaryText="Upload Warning"
        secondaryText="If you upload audio then your current audios will be removed, are you sure ?"
        visible={uploadWarning}
        positiveText={"Yes"}
        negativeText={"No"}
        positiveClick={() => {
          setUploadWarning(false);
          upload.current.click();
        }}
        negativeClick={() => {
          setUploadWarning(false);
        }}
        toggleModal={(flag) => setUploadWarning(flag)}
      ></Confirmation>
    </>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  card: {
    backgroundColor: "#fff",
    width: "12rem",
    borderRadius: 17,
    shadowColor: "#000",
    boxShadow: "2rem",
  },
  card1: {
    backgroundColor: "#fff",
    borderRadius: 17,
    shadowColor: "#000",
    boxShadow: "2rem",
  },
  card2: {
    borderRadius: 17,
    width: "12rem",
    shadowColor: "#000",
    boxShadow: "2rem",
  },
  cardText: {
    fontSize: "0.7rem",
    paddingTop: 10,
    fontWeight: "900",
    marginLeft: 10,
    marginRight: 10,
  },
  className: {
    borderRadius: 20,
    color: "#DB8829",
    fontSize: "0.52rem",
    marginLeft: 10,
    marginRight: 10,
  },
  className1: {
    borderRadius: 20,
    color: "#828282",
    fontSize: "0.52rem",
    marginLeft: 10,
    marginRight: 10,
  },
});

export default RecordButtonForBroadcast;
